import { OnboardingStepStatus } from '../OnboardingStep/OnboardingStep'

export const getStepStatus = (completed: boolean, enabled: boolean) => {
  if (completed) return OnboardingStepStatus.COMPLETED
  if (enabled) return OnboardingStepStatus.PENDING
  return OnboardingStepStatus.DISABLED
}
